import {toJS} from 'mobx';

class ProcessBtnRendererVm {
    openWindow(customerId) {
        window.open(window.location.origin + `/refund/detail?customerId=${customerId}`, `refund${customerId}`, `width=1140, height=${window.screen.height}, toolbar=0,location=0,menubar=0`);
    }
}
export default new ProcessBtnRendererVm();